// extracted by mini-css-extract-plugin
module.exports = {"root":"Option_root__18v2S","disabled":"Option_disabled__1IKMZ","icon":"Option_icon__2XviP","selected":"Option_selected__3rRwf","content":"Option_content__v7BA2"};